import { render, staticRenderFns } from "./sso_complaint.vue?vue&type=template&id=5dba7761"
import script from "./sso_complaint.vue?vue&type=script&lang=js"
export * from "./sso_complaint.vue?vue&type=script&lang=js"
import style0 from "./sso_complaint.vue?vue&type=style&index=0&id=5dba7761&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports